<template>
	<Notification
		:titleArr="titleArr"
		:allowArchive="false"
		:notification="notification"
		:takeActionTitle="takeActionTitle"
		class="notification-preview-container"
	>
		<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
			<slot :name="slot" v-bind="scope" />
		</template>
	</Notification>
</template>

<script>
import Notification from '@/components/common/Notification.vue';
export default {
	name: 'BuilderNotification',
	components: { Notification },
	props: {
		icon: { type: String },
		title: { type: String },
		titleArr: { type: Array },
		additionalInfo: { type: String },
		takeActionTitle: { type: String },
	},
	computed: {
		notification() {
			return {
				archived: false,
				created_at: this.dateOnCreated,
				metadata: {
					title: this.title,
					icon_url: this.icon,
					subtitle: this.additionalInfo,
					action_title: this.takeActionTitle,
				},
			};
		},
	},
	data() {
		return { dateOnCreated: new Date().toISOString() };
	},
};
</script>

<style scoped lang="scss">
.notification-preview-container {
	width: 400px;
	min-height: 90px;
	border-radius: 8px;
	background: var(--bg-color);
	padding-left: 7px !important;
	border: 1px solid var(--border-color);
	box-shadow: 0px 3px 6px var(--shadow-color);
	::v-deep {
		.content-container {
			max-width: 320px !important;
		}
	}
}
</style>
